import { pendingNavHrefAtom } from '@/atoms/sideNavAtoms';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import {
  isWorkChatLandingPath,
  WORK_CHAT_HOME_PATH,
  workHomeHref,
} from '@heidi/agents/contracts';

/**
 * Open the hardcoded routine-creation chat on the Work home. Does not create a
 * backend project — that happens on the user's first submit.
 */
export function useOpenRoutineCreateChat(): () => void {
  const router = useRouter();
  const setPendingNavHref = useSetAtom(pendingNavHrefAtom);

  return useCallback(() => {
    // On the Work landing a same-path push fires no routeChangeComplete,
    // so a pending write would never clear and Home would stay stuck-selected.
    if (!isWorkChatLandingPath(router.asPath)) {
      setPendingNavHref(WORK_CHAT_HOME_PATH);
    }
    void router.push(workHomeHref({ view: 'create-routine' }), undefined, {
      shallow: true,
    });
  }, [router, setPendingNavHref]);
}
